export default "__VITE_ASSET__1BZ6iU5D__"